import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { STORAGE_PREFIX } from '../../config/env';

export type Tema = 'oscuro' | 'claro';

interface EstadoTema {
  tema: Tema;
  alternar: () => void;
  establecer: (tema: Tema) => void;
}

/** Aplica el tema al documento. El CSS reacciona al atributo `data-theme`. */
function aplicar(tema: Tema): void {
  document.documentElement.dataset.theme = tema === 'claro' ? 'light' : 'dark';
}

export const useTemaStore = create<EstadoTema>()(
  persist(
    (set, get) => ({
      // La consola arranca en claro, igual que la versión actual; el oscuro
      // es la alternativa que el usuario elige.
      tema: 'claro',

      alternar: () => {
        const nuevo: Tema = get().tema === 'oscuro' ? 'claro' : 'oscuro';
        aplicar(nuevo);
        set({ tema: nuevo });
      },

      establecer: (tema) => {
        aplicar(tema);
        set({ tema });
      },
    }),
    {
      name: `${STORAGE_PREFIX}tema`,
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (estado) => {
        // Al recuperar la preferencia guardada hay que reflejarla en el DOM;
        // el script del index.html ya lo hizo, esto lo mantiene sincronizado.
        if (estado) aplicar(estado.tema);
      },
    },
  ),
);
